<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav>
        <h4 class="mb-0">{{title}}</h4>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-row>
          <b-col>
            <ExportSidebar
              sidebar-id="sidebar-organizations-export"
              storage-key="sidebar_organizations_export"
              :columns="organizationsExportColumns"
              :data-to-export="items"
              :data-mapper="mapOrganizationForExport"
              file-name="Organizations.xlsx"
              sheet-name="Organizations"
              :is-busy="isBusy"
              :items-count="totalRows"
            />
          </b-col>
          <b-col cols="auto">
            <b-button id="table-settings" size="sm" variant="warning" class="mr-2" v-b-toggle.sidebar-fields>
              <font-awesome-icon icon="cog"/>
            </b-button>
            <b-tooltip target="table-settings" triggers="hover" variant="warning" noninteractive>
              Колонки
            </b-tooltip>
            <b-btn
              v-if="canEditOrganizations()"
              size="sm"
              variant="success"
              :disabled="isBusy"
              @click="showModal(null, false)"
            >
              <b-spinner v-if="isBusy" small/>
              <font-awesome-icon icon="plus" class="mr-1"/>
              {{ $t("message.organizations.importHand") }}
            </b-btn>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-navbar variant="light">
      <b-navbar-nav>
        <filters-drawer
          :query.sync="filters.query"
          :is-busy="isBusy"
          @submit="onSearch"
          hide-search-button
        />
      </b-navbar-nav>
    </b-navbar>

    <b-table
      id="organizations"
      ref="organizations"
      class="mb-0 text-small"
      selectable
      select-mode="single"
      selectedVariant="success"
      striped
      small
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy.sync="isBusy"
      :items="items"
      :fields="renderedFields"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      no-local-sorting
      @sort-changed="sortChanged"
      @row-dblclicked="onRowClicked"
      sticky-header
      head-variant="light"
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"/>
          <strong>Загрузка</strong>
        </div>
      </template>
      <template #cell(address)="row">
        <div v-if="row.item.address.length<50">{{ row.item.address }}</div>
        <div v-else>{{ row.item.address.substring(0, 50) + ".." }}</div>
      </template>
      <template #cell(action)="row">
        <b-dropdown size="sm" no-caret>
          <template #button-content>
            <font-awesome-icon icon="ellipsis-v"/>
          </template>
          <b-dropdown-item-button variant="success" @click.stop="showModal(row.item.id,true)">
            <font-awesome-icon icon="eye"/>
            Смотреть
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="canEditOrganizations()" variant="primary" @click="showModal(row.item.id,false)">
            <font-awesome-icon icon="edit"/>
            Редактировать
          </b-dropdown-item-button>
          <b-dropdown-item-button v-if="canEditOrganizations()" variant="danger" @click="onRemove(row)">
            <font-awesome-icon icon="trash"/>
            Удалить
          </b-dropdown-item-button>
        </b-dropdown>
      </template>

      <template #cell(phone)="row">
        <a :href=telUrl(row.item.phone)>{{phoneString(row.item.phone)}}</a>
      </template>
    </b-table>

    <pagination-footer
      :total-rows="totalRows"
      :per-page.sync="perPage"
      @page-click="onPagination"
      @per-page-change="onPerPageChange"
    />

    <organization ref="organization" v-on:refresh="getItems" @modal-closed="onModalClosed"></organization>

    <DynamicTables
      storage-key="organizations_columns"
      sidebar-fields="sidebar-fields"
      :fields-model.sync="fields"
      :serviceEndField="serviceEndField"
      fieldKey="name"
    />

  </div>
</template>

<script>
import organizations from "../../network/organizations";
  import helpers from "../../utilites/helpers";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
  import FiltersDrawer from "../../utilites/commonUi/FiltersDrawer.vue";
  import ExportSidebar from "../../utilites/commonUi/ExportSidebar.vue";
  import permissions, {PERM} from "../../utilites/permissions";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
    import Organization from "./Organization";

export default {
  name: "Organizations",
  components: { PaginationFooter, ExportSidebar, FiltersDrawer, DynamicTables, Organization },
  mixins: [
    organizations,
    helpers, permissions, pageSearchService
  ],
  data() {
    return {
      title: 'Организации',
      items: [],
      fields: [
        {
          key: 'name',
          label: this.$t('message.customers.table.name'),
          sortable: true,
          class: 'organizationsName',
          visible: true,
        },
        {
          key: 'inn',
          label: this.$t('message.customers.table.inn'),
          sortable: true,
          visible: true,
        },
        {
          key: 'kpp',
          label: this.$t('message.customers.table.kpp'),
          sortable: true,
          visible: true,
        },
        {
          key: 'ogrn',
          label: this.$t('message.customers.table.ogrn'),
          sortable: true,
          visible: true,
        },
        {
          key: 'phone',
          label: this.$t('message.customers.table.phone'),
          sortable: true,
          visible: true,
        },
        {
          key: 'address',
          label: this.$t('message.customers.table.address'),
          sortable: true,
          visible: true,
        },
      ],
      serviceEndField: {
        key: 'action',
        label: this.$t('message.customers.table.actions'),
        class: 'organizationsAction',
      },
      sortBy: 'name',
      sortDesc: true,
      isBusy: false,
      filters: {
        query: '',
      },
      deleteRow: {
        id: null,
        name: '',
      },
      organizationsExportColumns: {
        "Название": true,
        "ИНН": true,
        "КПП": true,
        "ОГРН": true,
        "Телефон": true,
        "Адрес": true,
      },
    }
  },
  async created() {
    const query = this.$route.query;

    if (query && query.query) {
      this.filters.query = query.query;
    }

    if (this.$route.hash) {
      this.currentPage = this.getPage(this.$route.hash);
    }

    await this.onSearch();
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible);
    },
    renderedFields() {
      return [
        ...this.visibleFields,
        this.serviceEndField
      ];
    }
  },
  methods: {
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.filters.query,
        sortBy: [this.sortBy],
        sortDesc: [this.sortDesc],
      };

      this.isBusy = true;
      const result = await this.getOrganizations(data);
      this.isBusy = false;

      if (!result || !result.data) {
        this.items = [];
        this.isBusy = false;
        this.totalRows = 0;
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.items = result.data.items;
      this.totalRows = result.data.total;
    },
    showModal(organizationId, isViewonly) {
      const canEdit = this.canEditOrganizations();

      if (!organizationId) {
        if (!canEdit) return;

        this.$refs.organization.showModal(null, false);
        return;
      }

      const isView = isViewonly || !canEdit;
      const query = isView ? { mode: 'view' } : {};

      this.$router.push({
        name: 'Organizations',
        params: { id: organizationId },
        query: query
      });
    },
    onRowClicked(item) {
      this.showModal(item.id, false);
    },
    onModalClosed() {
      if (this.$route.params.id) {
        this.$router.replace({
          name: 'Organizations',
          params: { id: null },
          hash: this.$route.hash,
        }).catch(()=>{});
      }
    },
    onRemove(row) {
      if (!this.canEditOrganizations()) return;

      if (row.item) {
        this.deleteRow = row.item
      }

      const title = this.$t('message.organizations.modal.removeTitle');
      const message = `${this.$t("message.organizations.modal.removeDesc")} "${this.deleteRow.name}"?`;
      this.showModalDelete(title, message, async () => {
        const result = await this.deleteOrganization(this.deleteRow);

        if (result.error) {
          this.showToast('Ошибка при удалении.', 'Ошибка', 'danger');
        } else {
          this.showToast('Организация удалена.', 'Успех', 'success');
          await this.getItems();
        }
      });
    },
    // Export
    mapOrganizationForExport(item, selectedColumns) {
      const config = {
        "Название": item.name,
        "ИНН": item.inn,
        "КПП": item.kpp,
        "ОГРН": item.ogrn,
        "Телефон": item.phone,
        "Адрес": item.address,
      };
      const excelData = {};

      for (const key in config) if (selectedColumns[key]) {
        excelData[key] = config[key];
      }
      return excelData;
    },
    // Permissions
    canEditOrganizations() {
      return this.hasPermission([PERM.ORGANIZATION_EDIT]);
    }
  },
  watch: {
    '$route.params.id': {
      handler(newId) {
        this.$nextTick(() => {
          if (newId && this.$refs.organization) {
            const isViewonly = this.$route.query.mode === 'view';
            this.$refs.organization.showModal(newId, isViewonly);
          } else if (!newId && this.$refs.organization) {
            this.$refs.organization.hideModal();
          }
        });
      }, immediate: true
    },
  }
}
</script>

<style>
@media screen
and (min-width: 768px) {
  a[href*="tel:"] {
    pointer-events: none;
    cursor:default;
    text-decoration: none;
  }
}

.organizationsName {
  padding-left: 10px !important;
  min-width: 200px;
  max-width: 300px;
}

.organizationsAction {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Organizations/Organizations.vue